import { createFileRoute } from '@tanstack/react-router'
import { StudioSettings } from '~/components/settings/institutional/studio-settings'

export const Route = createFileRoute('/_authenticated/$workspaceSlug/settings/studio')({
  component: StudioRoute,
})

/**
 * The workspace's studio profile — the institutional content (about text,
 * studio photos, testimonials, process steps) that generated client-facing
 * documents render live. Editing is admin-only; members see it read-only.
 */
function StudioRoute() {
  return <StudioSettings />
}
